import { Feature } from "ts/enums/feature";
import config from "../appSettings.json";
import { useAppSelector } from "store";

export const IsFeatureActive = (feature: Feature) => {
  const { features } = useAppSelector((state) => state.settings);
  return config.features?.[feature] || features?.[feature];
};
